import { Navigate, useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import React, { Suspense, lazy, useEffect } from 'react';

import { AppLoading } from '../../loaders/loaders.js';
import DispatchHeader from './dispatchHeader/index.js';
import IbplanningHeader from './ibplanningHeader/index.js';
import ShipmentSelectionHeader from './customHeader/index.js';
import appConstants from '../../appConstants';

const ShowCustomerEditPopup = lazy(() => import('../modules/Common/ShowCustomerEditPopup.js'));

const AppHeader = ({ glEventHub, featureFlags, userData, isNotificationVisible, configJSON }) => {
  const isStoredDispatchHeaderActive = JSON.parse(localStorage.getItem('isDispatchHeaderActive'));
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const customerCode = searchParams.get('customerCode');
  const url = location.pathname;

  useEffect(() => {
    if (location.state?.closeOnRefresh) {
      //closing popups on refresh page
      navigate(url, { replace: true });
    }
  }, []);
  const isDispatchHeaderActive =
    url.includes(appConstants.NAV_URLS.DISPATCH_HOME) ||
    (!url.includes(appConstants.NAV_URLS.IBPLANNING_HOME) && isStoredDispatchHeaderActive);

  if (isStoredDispatchHeaderActive !== isDispatchHeaderActive) {
    localStorage.setItem('isDispatchHeaderActive', isDispatchHeaderActive);
  }

  let customTabInfo = null;
  if (url.includes(appConstants.NAV_URLS.SHIPMENT_SELECTION)) {
    customTabInfo = {
      label: 'Shipment Selection',
      id: 'shipmentSelectionHeader',
      path: appConstants.NAV_URLS.SHIPMENT_SELECTION,
      isEnabled: featureFlags?.isFeatureEnabled?.(appConstants.features.EnableShipmentSelection)
    };
  } else if (url.includes(appConstants.NAV_URLS.SHIPMENT_FORECAST)) {
    if (!configJSON.enableShipmentForecast) {
      return <Navigate to={appConstants.NAV_URLS.ACCESS_DENIED} />;
    }
    customTabInfo = {
      label: 'Shipment Forecast',
      id: 'shipmentForecastHeader',
      path: appConstants.NAV_URLS.SHIPMENT_FORECAST,
      isEnabled: true
    };
  }

  if (customTabInfo) {
    return (
      <ShipmentSelectionHeader
        customTabInfo={customTabInfo}
        glEventHub={glEventHub}
        featureFlags={featureFlags}
      />
    );
  }
  const ModuleComponent = isDispatchHeaderActive ? DispatchHeader : IbplanningHeader;
  return (
    <>
      <div>
        {isDispatchHeaderActive && !userData.userProfile.enableDispatch ? (
          <Navigate to={appConstants.NAV_URLS.ACCESS_DENIED} />
        ) : (
          <ModuleComponent glEventHub={glEventHub} featureFlags={featureFlags} />
        )}
      </div>
      <Suspense fallback={<AppLoading />}>
        {customerCode && (
          <ShowCustomerEditPopup
            customerCode={customerCode}
            glEventHub={glEventHub}
            isNotificationVisible={isNotificationVisible}
          />
        )}
      </Suspense>
    </>
  );
};

export default AppHeader;
